/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/tool_catalog_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  RpcStatus,
  ToolCatalogServiceAddToolAdapterBody,
  ToolCatalogServiceCreateToolSourceBody,
  ToolCatalogServiceDisableToolsBody,
  ToolCatalogServiceEnableToolsBody,
  ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody,
  ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody,
  ToolCatalogServiceListToolAdapterDynamicEnumValuesBody,
  ToolCatalogServiceListToolSourceDynamicEnumValuesBody,
  ToolCatalogServicePreviewToolAdapterChainBody,
  ToolCatalogServiceReorderToolAdaptersBody,
  ToolCatalogServiceSetEnabledToolsBody,
  ToolCatalogServiceSetToolAdaptersBody,
  ToolCatalogServiceUpdateToolAdapterBody,
  ToolCatalogServiceUpdateToolBody,
  ToolCatalogServiceUpdateToolSourceBody,
  ToolCatalogServiceValidateToolAdapterConfigSchemaBody,
  ToolCatalogServiceValidateToolSourceConfigSchemaBody,
  V1DiffToolSourcesResponse,
  V1DiffToolsResponse,
  V1DynamicEnumValuesResponse,
  V1GetConfigSchemaResponse,
  V1GetToolAdapterChainResponse,
  V1GetToolAdapterResponse,
  V1ListToolAdapterKindsResponse,
  V1ListToolAdaptersResponse,
  V1ListToolSourceKindsResponse,
  V1ListToolSourcesResponse,
  V1ListToolsResponse,
  V1PreviewToolAdapterChainResponse,
  V1Tool,
  V1ToolAdapterDescriptor,
  V1ToolEnablement,
  V1ToolSource,
  V1ValidateConfigResponse,
  WorkspaceDeleteToolSource200,
  WorkspaceDeleteToolSourceParams,
  WorkspaceDiffToolSourcesParams,
  WorkspaceDiffToolsParams,
  WorkspaceDisableToolParams,
  WorkspaceEnableToolParams,
  WorkspaceGetStaticToolAdapterConfigSchemaParams,
  WorkspaceGetStaticToolSourceConfigSchemaParams,
  WorkspaceGetToolAdapterChainParams,
  WorkspaceGetToolAdapterParams,
  WorkspaceListToolAdaptersParams,
  WorkspaceListToolSourcesParams,
  WorkspaceListToolsParams,
  WorkspaceRemoveAllToolAdapters200,
  WorkspaceRemoveAllToolAdaptersParams,
  WorkspaceRemoveToolAdapter200,
  WorkspaceRemoveToolAdapterParams,
} from '../../models';

/**
 * @summary Lists tool sources configured for a thread.
 */
export const workspaceListToolSources = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolSourcesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolSourcesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListToolSourcesQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceListToolSourcesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListToolSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListToolSourcesQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListToolSources>>
  > = ({ signal }) =>
    workspaceListToolSources(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListToolSources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListToolSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListToolSources>>
>;
export type WorkspaceListToolSourcesQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListToolSources<
  TData = Awaited<ReturnType<typeof workspaceListToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceListToolSourcesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSources>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolSources>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolSources>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolSources<
  TData = Awaited<ReturnType<typeof workspaceListToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSources>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolSources>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolSources>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolSources<
  TData = Awaited<ReturnType<typeof workspaceListToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists tool sources configured for a thread.
 */

export function useWorkspaceListToolSources<
  TData = Awaited<ReturnType<typeof workspaceListToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListToolSourcesQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new tool source for a thread.
 */
export const workspaceCreateToolSource = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolCatalogServiceCreateToolSourceBody: ToolCatalogServiceCreateToolSourceBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolSource>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources`,
    toolCatalogServiceCreateToolSourceBody,
    options,
  );
};

export const getWorkspaceCreateToolSourceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCreateToolSource>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ToolCatalogServiceCreateToolSourceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCreateToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ToolCatalogServiceCreateToolSourceBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceCreateToolSource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCreateToolSource>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ToolCatalogServiceCreateToolSourceBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceCreateToolSource(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCreateToolSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCreateToolSource>>
>;
export type WorkspaceCreateToolSourceMutationBody =
  ToolCatalogServiceCreateToolSourceBody;
export type WorkspaceCreateToolSourceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new tool source for a thread.
 */
export const useWorkspaceCreateToolSource = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCreateToolSource>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ToolCatalogServiceCreateToolSourceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCreateToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ToolCatalogServiceCreateToolSourceBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceCreateToolSourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deletes a tool source from a thread.
 */
export const workspaceDeleteToolSource = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  params?: WorkspaceDeleteToolSourceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteToolSource200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources/${sourceId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteToolSourceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteToolSource>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      params?: WorkspaceDeleteToolSourceParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    params?: WorkspaceDeleteToolSourceParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteToolSource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteToolSource>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      params?: WorkspaceDeleteToolSourceParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, sourceId, params } =
      props ?? {};

    return workspaceDeleteToolSource(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteToolSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteToolSource>>
>;

export type WorkspaceDeleteToolSourceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a tool source from a thread.
 */
export const useWorkspaceDeleteToolSource = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteToolSource>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        params?: WorkspaceDeleteToolSourceParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    params?: WorkspaceDeleteToolSourceParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteToolSourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a tool source's configuration on a thread.
 */
export const workspaceUpdateToolSource = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolCatalogServiceUpdateToolSourceBody: ToolCatalogServiceUpdateToolSourceBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolSource>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources/${sourceId}`,
    toolCatalogServiceUpdateToolSourceBody,
    options,
  );
};

export const getWorkspaceUpdateToolSourceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateToolSource>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceUpdateToolSourceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceUpdateToolSourceBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateToolSource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateToolSource>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceUpdateToolSourceBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, sourceId, data } =
      props ?? {};

    return workspaceUpdateToolSource(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateToolSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateToolSource>>
>;
export type WorkspaceUpdateToolSourceMutationBody =
  ToolCatalogServiceUpdateToolSourceBody;
export type WorkspaceUpdateToolSourceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a tool source's configuration on a thread.
 */
export const useWorkspaceUpdateToolSource = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateToolSource>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        data: ToolCatalogServiceUpdateToolSourceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateToolSource>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceUpdateToolSourceBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateToolSourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the thread's effective tool sources (including adapters
and enabled tool sets) and the pinned agent version's tool sources
side-by-side so callers can render a diff.
 */
export const workspaceDiffToolSources = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolSourcesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffToolSourcesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDiffToolSourcesQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceDiffToolSourcesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-sources:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceDiffToolSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceDiffToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceDiffToolSourcesQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceDiffToolSources>>
  > = ({ signal }) =>
    workspaceDiffToolSources(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceDiffToolSources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceDiffToolSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffToolSources>>
>;
export type WorkspaceDiffToolSourcesQueryError = AxiosError<RpcStatus>;

export function useWorkspaceDiffToolSources<
  TData = Awaited<ReturnType<typeof workspaceDiffToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceDiffToolSourcesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffToolSources>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffToolSources>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffToolSources>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffToolSources<
  TData = Awaited<ReturnType<typeof workspaceDiffToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffToolSources>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffToolSources>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffToolSources>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffToolSources<
  TData = Awaited<ReturnType<typeof workspaceDiffToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the thread's effective tool sources (including adapters
and enabled tool sets) and the pinned agent version's tool sources
side-by-side so callers can render a diff.
 */

export function useWorkspaceDiffToolSources<
  TData = Awaited<ReturnType<typeof workspaceDiffToolSources>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolSourcesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffToolSources>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceDiffToolSourcesQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists the flat tool catalog for a thread (one entry per enabled
tool across all sources). Reflects per-thread enablement and
adapter overrides; the agent's read-only base catalog is exposed
by `DiffTools.base`.
 */
export const workspaceListTools = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListToolsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceListToolsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListToolsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListToolsQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListTools>>
  > = ({ signal }) =>
    workspaceListTools(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListTools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListToolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListTools>>
>;
export type WorkspaceListToolsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListTools<
  TData = Awaited<ReturnType<typeof workspaceListTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceListToolsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListTools>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListTools>>,
          TError,
          Awaited<ReturnType<typeof workspaceListTools>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListTools<
  TData = Awaited<ReturnType<typeof workspaceListTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListTools>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListTools>>,
          TError,
          Awaited<ReturnType<typeof workspaceListTools>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListTools<
  TData = Awaited<ReturnType<typeof workspaceListTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists the flat tool catalog for a thread (one entry per enabled
tool across all sources). Reflects per-thread enablement and
adapter overrides; the agent's read-only base catalog is exposed
by `DiffTools.base`.
 */

export function useWorkspaceListTools<
  TData = Awaited<ReturnType<typeof workspaceListTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListToolsQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates a tool's effective view (name, description, parameter
descriptions, status template, is_remote, requires_approval). The server
diffs the desired metadata against the tool's upstream view and creates,
updates, or removes the underlying (hidden) metadata adapter as needed.
Returns the tool's updated effective view.
 */
export const workspaceUpdateTool = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  toolCatalogServiceUpdateToolBody: ToolCatalogServiceUpdateToolBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Tool>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}`,
    toolCatalogServiceUpdateToolBody,
    options,
  );
};

export const getWorkspaceUpdateToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceUpdateToolBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceUpdateToolBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateTool>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceUpdateToolBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
    } = props ?? {};

    return workspaceUpdateTool(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateTool>>
>;
export type WorkspaceUpdateToolMutationBody = ToolCatalogServiceUpdateToolBody;
export type WorkspaceUpdateToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a tool's effective view (name, description, parameter
descriptions, status template, is_remote, requires_approval). The server
diffs the desired metadata against the tool's upstream view and creates,
updates, or removes the underlying (hidden) metadata adapter as needed.
Returns the tool's updated effective view.
 */
export const useWorkspaceUpdateTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        data: ToolCatalogServiceUpdateToolBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceUpdateToolBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists adapters configured for a tool on a thread.
 */
export const workspaceListToolAdapters = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceListToolAdaptersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolAdaptersResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListToolAdaptersQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  sourceId?: string,
  toolId?: string,
  params?: WorkspaceListToolAdaptersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListToolAdaptersQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListToolAdapters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceListToolAdaptersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListToolAdaptersQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListToolAdapters>>
  > = ({ signal }) =>
    workspaceListToolAdapters(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      sourceId &&
      toolId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListToolAdapters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListToolAdaptersQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListToolAdapters>>
>;
export type WorkspaceListToolAdaptersQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListToolAdapters<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params: undefined | WorkspaceListToolAdaptersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapters>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolAdapters>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolAdapters>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolAdapters<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceListToolAdaptersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapters>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolAdapters>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolAdapters>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolAdapters<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceListToolAdaptersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists adapters configured for a tool on a thread.
 */

export function useWorkspaceListToolAdapters<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceListToolAdaptersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListToolAdaptersQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    sourceId,
    toolId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Removes all adapters from a tool on a thread.
 */
export const workspaceRemoveAllToolAdapters = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceRemoveAllToolAdaptersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceRemoveAllToolAdapters200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceRemoveAllToolAdaptersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceRemoveAllToolAdaptersParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceRemoveAllToolAdaptersParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceRemoveAllToolAdapters'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceRemoveAllToolAdaptersParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
    } = props ?? {};

    return workspaceRemoveAllToolAdapters(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceRemoveAllToolAdaptersMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>
>;

export type WorkspaceRemoveAllToolAdaptersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes all adapters from a tool on a thread.
 */
export const useWorkspaceRemoveAllToolAdapters = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        params?: WorkspaceRemoveAllToolAdaptersParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceRemoveAllToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceRemoveAllToolAdaptersParams;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceRemoveAllToolAdaptersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Adds an adapter to a tool's chain on a thread (appended at end).
 */
export const workspaceAddToolAdapter = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  toolCatalogServiceAddToolAdapterBody: ToolCatalogServiceAddToolAdapterBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolAdapterDescriptor>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters`,
    toolCatalogServiceAddToolAdapterBody,
    options,
  );
};

export const getWorkspaceAddToolAdapterMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceAddToolAdapter>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceAddToolAdapterBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceAddToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceAddToolAdapterBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceAddToolAdapter'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceAddToolAdapter>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceAddToolAdapterBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
    } = props ?? {};

    return workspaceAddToolAdapter(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceAddToolAdapterMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceAddToolAdapter>>
>;
export type WorkspaceAddToolAdapterMutationBody =
  ToolCatalogServiceAddToolAdapterBody;
export type WorkspaceAddToolAdapterMutationError = AxiosError<RpcStatus>;

/**
 * @summary Adds an adapter to a tool's chain on a thread (appended at end).
 */
export const useWorkspaceAddToolAdapter = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceAddToolAdapter>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        data: ToolCatalogServiceAddToolAdapterBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceAddToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceAddToolAdapterBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceAddToolAdapterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reorders the adapter chain for a tool on a thread.
 */
export const workspaceReorderToolAdapters = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  toolCatalogServiceReorderToolAdaptersBody: ToolCatalogServiceReorderToolAdaptersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolAdaptersResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters`,
    toolCatalogServiceReorderToolAdaptersBody,
    options,
  );
};

export const getWorkspaceReorderToolAdaptersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceReorderToolAdapters>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceReorderToolAdaptersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceReorderToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceReorderToolAdaptersBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceReorderToolAdapters'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceReorderToolAdapters>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceReorderToolAdaptersBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
    } = props ?? {};

    return workspaceReorderToolAdapters(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceReorderToolAdaptersMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceReorderToolAdapters>>
>;
export type WorkspaceReorderToolAdaptersMutationBody =
  ToolCatalogServiceReorderToolAdaptersBody;
export type WorkspaceReorderToolAdaptersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Reorders the adapter chain for a tool on a thread.
 */
export const useWorkspaceReorderToolAdapters = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceReorderToolAdapters>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        data: ToolCatalogServiceReorderToolAdaptersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceReorderToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceReorderToolAdaptersBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceReorderToolAdaptersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a tool adapter with the tool descriptor at that adapter stage.
Use adapter_id ":root" to get the original unadapted tool descriptor.
 */
export const workspaceGetToolAdapter = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceGetToolAdapterParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetToolAdapterResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters/${adapterId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetToolAdapterQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  sourceId?: string,
  toolId?: string,
  adapterId?: string,
  params?: WorkspaceGetToolAdapterParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters/${adapterId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetToolAdapterQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceGetToolAdapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetToolAdapterQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetToolAdapter>>
  > = ({ signal }) =>
    workspaceGetToolAdapter(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      sourceId &&
      toolId &&
      adapterId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetToolAdapterQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetToolAdapter>>
>;
export type WorkspaceGetToolAdapterQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetToolAdapter<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params: undefined | WorkspaceGetToolAdapterParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetToolAdapter>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetToolAdapter<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceGetToolAdapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetToolAdapter>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetToolAdapter<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceGetToolAdapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a tool adapter with the tool descriptor at that adapter stage.
Use adapter_id ":root" to get the original unadapted tool descriptor.
 */

export function useWorkspaceGetToolAdapter<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceGetToolAdapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapter>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetToolAdapterQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    sourceId,
    toolId,
    adapterId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Removes a specific adapter from a tool's chain on a thread.
 */
export const workspaceRemoveToolAdapter = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  params?: WorkspaceRemoveToolAdapterParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceRemoveToolAdapter200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters/${adapterId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceRemoveToolAdapterMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      adapterId: string;
      params?: WorkspaceRemoveToolAdapterParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    adapterId: string;
    params?: WorkspaceRemoveToolAdapterParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceRemoveToolAdapter'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      adapterId: string;
      params?: WorkspaceRemoveToolAdapterParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      params,
    } = props ?? {};

    return workspaceRemoveToolAdapter(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceRemoveToolAdapterMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>
>;

export type WorkspaceRemoveToolAdapterMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes a specific adapter from a tool's chain on a thread.
 */
export const useWorkspaceRemoveToolAdapter = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        adapterId: string;
        params?: WorkspaceRemoveToolAdapterParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceRemoveToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    adapterId: string;
    params?: WorkspaceRemoveToolAdapterParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceRemoveToolAdapterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an adapter's configuration on a thread.
 */
export const workspaceUpdateToolAdapter = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  adapterId: string,
  toolCatalogServiceUpdateToolAdapterBody: ToolCatalogServiceUpdateToolAdapterBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolAdapterDescriptor>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters/${adapterId}`,
    toolCatalogServiceUpdateToolAdapterBody,
    options,
  );
};

export const getWorkspaceUpdateToolAdapterMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      adapterId: string;
      data: ToolCatalogServiceUpdateToolAdapterBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    adapterId: string;
    data: ToolCatalogServiceUpdateToolAdapterBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateToolAdapter'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      adapterId: string;
      data: ToolCatalogServiceUpdateToolAdapterBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      data,
    } = props ?? {};

    return workspaceUpdateToolAdapter(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      adapterId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateToolAdapterMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>
>;
export type WorkspaceUpdateToolAdapterMutationBody =
  ToolCatalogServiceUpdateToolAdapterBody;
export type WorkspaceUpdateToolAdapterMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an adapter's configuration on a thread.
 */
export const useWorkspaceUpdateToolAdapter = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        adapterId: string;
        data: ToolCatalogServiceUpdateToolAdapterBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateToolAdapter>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    adapterId: string;
    data: ToolCatalogServiceUpdateToolAdapterBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateToolAdapterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the resolved adapter chain for a tool with the descriptor
view at every position — what the chain editor needs to render
wire schemas and pin rows without N round-trips.
 */
export const workspaceGetToolAdapterChain = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceGetToolAdapterChainParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetToolAdapterChainResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters:chain`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetToolAdapterChainQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  sourceId?: string,
  toolId?: string,
  params?: WorkspaceGetToolAdapterChainParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters:chain`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetToolAdapterChainQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceGetToolAdapterChainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetToolAdapterChainQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>
  > = ({ signal }) =>
    workspaceGetToolAdapterChain(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      sourceId &&
      toolId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetToolAdapterChainQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>
>;
export type WorkspaceGetToolAdapterChainQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetToolAdapterChain<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params: undefined | WorkspaceGetToolAdapterChainParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetToolAdapterChain<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceGetToolAdapterChainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetToolAdapterChain<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceGetToolAdapterChainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the resolved adapter chain for a tool with the descriptor
view at every position — what the chain editor needs to render
wire schemas and pin rows without N round-trips.
 */

export function useWorkspaceGetToolAdapterChain<
  TData = Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceGetToolAdapterChainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetToolAdapterChain>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetToolAdapterChainQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    sourceId,
    toolId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Returns the resolved view of a *draft* (unsaved) adapter chain.
Used by the chain editor as the user edits — partial wires render
below a position whose filter fails inference, with the failing
position's `errors` envelope carrying the diagnostic.
 */
export const workspacePreviewToolAdapterChain = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  toolCatalogServicePreviewToolAdapterChainBody: ToolCatalogServicePreviewToolAdapterChainBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PreviewToolAdapterChainResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters:preview`,
    toolCatalogServicePreviewToolAdapterChainBody,
    options,
  );
};

export const getWorkspacePreviewToolAdapterChainMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServicePreviewToolAdapterChainBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServicePreviewToolAdapterChainBody;
  },
  TContext
> => {
  const mutationKey = ['workspacePreviewToolAdapterChain'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServicePreviewToolAdapterChainBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
    } = props ?? {};

    return workspacePreviewToolAdapterChain(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacePreviewToolAdapterChainMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>
>;
export type WorkspacePreviewToolAdapterChainMutationBody =
  ToolCatalogServicePreviewToolAdapterChainBody;
export type WorkspacePreviewToolAdapterChainMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Returns the resolved view of a *draft* (unsaved) adapter chain.
Used by the chain editor as the user edits — partial wires render
below a position whose filter fails inference, with the failing
position's `errors` envelope carrying the diagnostic.
 */
export const useWorkspacePreviewToolAdapterChain = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        data: ToolCatalogServicePreviewToolAdapterChainBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspacePreviewToolAdapterChain>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServicePreviewToolAdapterChainBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspacePreviewToolAdapterChainMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Replaces a tool's entire editable adapter chain in one atomic call.
The system-managed metadata adapter is preserved. Returns the new chain
(excluding metadata).
 */
export const workspaceSetToolAdapters = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  toolCatalogServiceSetToolAdaptersBody: ToolCatalogServiceSetToolAdaptersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolAdaptersResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}/adapters:set`,
    toolCatalogServiceSetToolAdaptersBody,
    options,
  );
};

export const getWorkspaceSetToolAdaptersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSetToolAdapters>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceSetToolAdaptersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSetToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceSetToolAdaptersBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSetToolAdapters'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSetToolAdapters>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      data: ToolCatalogServiceSetToolAdaptersBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
    } = props ?? {};

    return workspaceSetToolAdapters(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSetToolAdaptersMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSetToolAdapters>>
>;
export type WorkspaceSetToolAdaptersMutationBody =
  ToolCatalogServiceSetToolAdaptersBody;
export type WorkspaceSetToolAdaptersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Replaces a tool's entire editable adapter chain in one atomic call.
The system-managed metadata adapter is preserved. Returns the new chain
(excluding metadata).
 */
export const useWorkspaceSetToolAdapters = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSetToolAdapters>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        data: ToolCatalogServiceSetToolAdaptersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSetToolAdapters>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    data: ToolCatalogServiceSetToolAdaptersBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSetToolAdaptersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Disables a single tool in a source on a thread.
 */
export const workspaceDisableTool = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceDisableToolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolEnablement>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}:disable`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDisableToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDisableTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceDisableToolParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDisableTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceDisableToolParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDisableTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDisableTool>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceDisableToolParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
    } = props ?? {};

    return workspaceDisableTool(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDisableToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDisableTool>>
>;

export type WorkspaceDisableToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Disables a single tool in a source on a thread.
 */
export const useWorkspaceDisableTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDisableTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        params?: WorkspaceDisableToolParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDisableTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceDisableToolParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDisableToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Enables a single tool in a source on a thread.
 */
export const workspaceEnableTool = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolId: string,
  params?: WorkspaceEnableToolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolEnablement>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}/${toolId}:enable`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceEnableToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEnableTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceEnableToolParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEnableTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceEnableToolParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceEnableTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEnableTool>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      toolId: string;
      params?: WorkspaceEnableToolParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
    } = props ?? {};

    return workspaceEnableTool(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      toolId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEnableToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEnableTool>>
>;

export type WorkspaceEnableToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Enables a single tool in a source on a thread.
 */
export const useWorkspaceEnableTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEnableTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        toolId: string;
        params?: WorkspaceEnableToolParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEnableTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    toolId: string;
    params?: WorkspaceEnableToolParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEnableToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Disables multiple tools in a source on a thread.
 */
export const workspaceDisableTools = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolCatalogServiceDisableToolsBody: ToolCatalogServiceDisableToolsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolEnablement>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}:disable`,
    toolCatalogServiceDisableToolsBody,
    options,
  );
};

export const getWorkspaceDisableToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDisableTools>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceDisableToolsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDisableTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceDisableToolsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDisableTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDisableTools>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceDisableToolsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, sourceId, data } =
      props ?? {};

    return workspaceDisableTools(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDisableToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDisableTools>>
>;
export type WorkspaceDisableToolsMutationBody =
  ToolCatalogServiceDisableToolsBody;
export type WorkspaceDisableToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Disables multiple tools in a source on a thread.
 */
export const useWorkspaceDisableTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDisableTools>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        data: ToolCatalogServiceDisableToolsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDisableTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceDisableToolsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDisableToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Enables multiple tools in a source on a thread (additive).
 */
export const workspaceEnableTools = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolCatalogServiceEnableToolsBody: ToolCatalogServiceEnableToolsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolEnablement>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}:enable`,
    toolCatalogServiceEnableToolsBody,
    options,
  );
};

export const getWorkspaceEnableToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEnableTools>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceEnableToolsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEnableTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceEnableToolsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEnableTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEnableTools>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceEnableToolsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, sourceId, data } =
      props ?? {};

    return workspaceEnableTools(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEnableToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEnableTools>>
>;
export type WorkspaceEnableToolsMutationBody =
  ToolCatalogServiceEnableToolsBody;
export type WorkspaceEnableToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Enables multiple tools in a source on a thread (additive).
 */
export const useWorkspaceEnableTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEnableTools>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        data: ToolCatalogServiceEnableToolsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEnableTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceEnableToolsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEnableToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Replaces the entire enabled tools set for a source on a thread.
 */
export const workspaceSetEnabledTools = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  sourceId: string,
  toolCatalogServiceSetEnabledToolsBody: ToolCatalogServiceSetEnabledToolsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ToolEnablement>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${sourceId}:set`,
    toolCatalogServiceSetEnabledToolsBody,
    options,
  );
};

export const getWorkspaceSetEnabledToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSetEnabledTools>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceSetEnabledToolsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSetEnabledTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceSetEnabledToolsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSetEnabledTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSetEnabledTools>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      sourceId: string;
      data: ToolCatalogServiceSetEnabledToolsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, sourceId, data } =
      props ?? {};

    return workspaceSetEnabledTools(
      organization,
      workspace,
      agentId,
      threadId,
      sourceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSetEnabledToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSetEnabledTools>>
>;
export type WorkspaceSetEnabledToolsMutationBody =
  ToolCatalogServiceSetEnabledToolsBody;
export type WorkspaceSetEnabledToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Replaces the entire enabled tools set for a source on a thread.
 */
export const useWorkspaceSetEnabledTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSetEnabledTools>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        sourceId: string;
        data: ToolCatalogServiceSetEnabledToolsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSetEnabledTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    sourceId: string;
    data: ToolCatalogServiceSetEnabledToolsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSetEnabledToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the thread's effective flat tool catalog and the pinned
agent version's catalog side-by-side so callers can render a
tool-level diff. Independent of `DiffToolSources`, which only
covers source identity.
 */
export const workspaceDiffTools = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffToolsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDiffToolsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceDiffToolsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceDiffToolsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceDiffTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceDiffToolsQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceDiffTools>>
  > = ({ signal }) =>
    workspaceDiffTools(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceDiffTools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceDiffToolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffTools>>
>;
export type WorkspaceDiffToolsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceDiffTools<
  TData = Awaited<ReturnType<typeof workspaceDiffTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceDiffToolsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffTools>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffTools>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffTools>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffTools<
  TData = Awaited<ReturnType<typeof workspaceDiffTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffTools>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffTools>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffTools>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffTools<
  TData = Awaited<ReturnType<typeof workspaceDiffTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the thread's effective flat tool catalog and the pinned
agent version's catalog side-by-side so callers can render a
tool-level diff. Independent of `DiffToolSources`, which only
covers source identity.
 */

export function useWorkspaceDiffTools<
  TData = Awaited<ReturnType<typeof workspaceDiffTools>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffTools>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceDiffToolsQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Dynamic (layer-2) config schema for a tool adapter kind, derived from its
static values. Returns an empty field list for non-dynamic kinds.
 */
export const workspaceGetDynamicToolAdapterConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceGetDynamicToolAdapterConfigSchemaBody: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-adapters:dynamic-config`,
    toolCatalogServiceGetDynamicToolAdapterConfigSchemaBody,
    options,
  );
};

export const getWorkspaceGetDynamicToolAdapterConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicToolAdapterConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceGetDynamicToolAdapterConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicToolAdapterConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>
  >;
export type WorkspaceGetDynamicToolAdapterConfigSchemaMutationBody =
  ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
export type WorkspaceGetDynamicToolAdapterConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for a tool adapter kind, derived from its
static values. Returns an empty field list for non-dynamic kinds.
 */
export const useWorkspaceGetDynamicToolAdapterConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicToolAdapterConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceGetDynamicToolAdapterConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicToolAdapterConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Re-resolves the dynamic option list for one tool adapter config field.
 */
export const workspaceListToolAdapterDynamicEnumValues = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceListToolAdapterDynamicEnumValuesBody: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DynamicEnumValuesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-adapters:dynamic-enum-values`,
    toolCatalogServiceListToolAdapterDynamicEnumValuesBody,
    options,
  );
};

export const getWorkspaceListToolAdapterDynamicEnumValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceListToolAdapterDynamicEnumValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceListToolAdapterDynamicEnumValues(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListToolAdapterDynamicEnumValuesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>
  >;
export type WorkspaceListToolAdapterDynamicEnumValuesMutationBody =
  ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
export type WorkspaceListToolAdapterDynamicEnumValuesMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Re-resolves the dynamic option list for one tool adapter config field.
 */
export const useWorkspaceListToolAdapterDynamicEnumValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListToolAdapterDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceListToolAdapterDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceListToolAdapterDynamicEnumValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for a tool adapter kind.
 */
export const workspaceGetStaticToolAdapterConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-adapters:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticToolAdapterConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetStaticToolAdapterConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-adapters:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticToolAdapterConfigSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticToolAdapterConfigSchemaQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticToolAdapterConfigSchema(
      organization,
      workspace,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticToolAdapterConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>
>;
export type WorkspaceGetStaticToolAdapterConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticToolAdapterConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticToolAdapterConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticToolAdapterConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for a tool adapter kind.
 */

export function useWorkspaceGetStaticToolAdapterConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolAdapterConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolAdapterConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetStaticToolAdapterConfigSchemaQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Validates a tool adapter's configuration without saving.
 */
export const workspaceValidateToolAdapterConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceValidateToolAdapterConfigSchemaBody: ToolCatalogServiceValidateToolAdapterConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-adapters:validate`,
    toolCatalogServiceValidateToolAdapterConfigSchemaBody,
    options,
  );
};

export const getWorkspaceValidateToolAdapterConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceValidateToolAdapterConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceValidateToolAdapterConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceValidateToolAdapterConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>
  >;
export type WorkspaceValidateToolAdapterConfigSchemaMutationBody =
  ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
export type WorkspaceValidateToolAdapterConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Validates a tool adapter's configuration without saving.
 */
export const useWorkspaceValidateToolAdapterConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceValidateToolAdapterConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceValidateToolAdapterConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceValidateToolAdapterConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Derives the dynamic (layer-2) config schema for a tool source kind from its
static (layer-1) values. Returns an empty field list for non-dynamic kinds.
 */
export const workspaceGetDynamicToolSourceConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceGetDynamicToolSourceConfigSchemaBody: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-sources:dynamic-config`,
    toolCatalogServiceGetDynamicToolSourceConfigSchemaBody,
    options,
  );
};

export const getWorkspaceGetDynamicToolSourceConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicToolSourceConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceGetDynamicToolSourceConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicToolSourceConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>
  >;
export type WorkspaceGetDynamicToolSourceConfigSchemaMutationBody =
  ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
export type WorkspaceGetDynamicToolSourceConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Derives the dynamic (layer-2) config schema for a tool source kind from its
static (layer-1) values. Returns an empty field list for non-dynamic kinds.
 */
export const useWorkspaceGetDynamicToolSourceConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicToolSourceConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceGetDynamicToolSourceConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicToolSourceConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Re-resolves the dynamic option list for one tool source config field.
 */
export const workspaceListToolSourceDynamicEnumValues = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceListToolSourceDynamicEnumValuesBody: ToolCatalogServiceListToolSourceDynamicEnumValuesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DynamicEnumValuesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-sources:dynamic-enum-values`,
    toolCatalogServiceListToolSourceDynamicEnumValuesBody,
    options,
  );
};

export const getWorkspaceListToolSourceDynamicEnumValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceListToolSourceDynamicEnumValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceListToolSourceDynamicEnumValues(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListToolSourceDynamicEnumValuesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>
  >;
export type WorkspaceListToolSourceDynamicEnumValuesMutationBody =
  ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
export type WorkspaceListToolSourceDynamicEnumValuesMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Re-resolves the dynamic option list for one tool source config field.
 */
export const useWorkspaceListToolSourceDynamicEnumValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListToolSourceDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceListToolSourceDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceListToolSourceDynamicEnumValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for a tool source kind.
 */
export const workspaceGetStaticToolSourceConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-sources:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticToolSourceConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetStaticToolSourceConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-sources:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticToolSourceConfigSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticToolSourceConfigSchemaQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticToolSourceConfigSchema(
      organization,
      workspace,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticToolSourceConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>
>;
export type WorkspaceGetStaticToolSourceConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticToolSourceConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticToolSourceConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticToolSourceConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for a tool source kind.
 */

export function useWorkspaceGetStaticToolSourceConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticToolSourceConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticToolSourceConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetStaticToolSourceConfigSchemaQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Validates a tool source's configuration without saving.
 */
export const workspaceValidateToolSourceConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  toolCatalogServiceValidateToolSourceConfigSchemaBody: ToolCatalogServiceValidateToolSourceConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/tool-sources:validate`,
    toolCatalogServiceValidateToolSourceConfigSchemaBody,
    options,
  );
};

export const getWorkspaceValidateToolSourceConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceValidateToolSourceConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceValidateToolSourceConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceValidateToolSourceConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ToolCatalogServiceValidateToolSourceConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceValidateToolSourceConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceValidateToolSourceConfigSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>
>;
export type WorkspaceValidateToolSourceConfigSchemaMutationBody =
  ToolCatalogServiceValidateToolSourceConfigSchemaBody;
export type WorkspaceValidateToolSourceConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Validates a tool source's configuration without saving.
 */
export const useWorkspaceValidateToolSourceConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ToolCatalogServiceValidateToolSourceConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceValidateToolSourceConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ToolCatalogServiceValidateToolSourceConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceValidateToolSourceConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists available tool adapter kinds and their configuration schemas.
 */
export const workspaceListToolAdapterKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolAdapterKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/tool-adapters/kinds`,
    options,
  );
};

export const getWorkspaceListToolAdapterKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/tool-adapters/kinds`,
  ] as const;
};

export const getWorkspaceListToolAdapterKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListToolAdapterKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>
  > = ({ signal }) =>
    workspaceListToolAdapterKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListToolAdapterKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>
>;
export type WorkspaceListToolAdapterKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListToolAdapterKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolAdapterKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolAdapterKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available tool adapter kinds and their configuration schemas.
 */

export function useWorkspaceListToolAdapterKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolAdapterKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListToolAdapterKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists available tool source kinds and their configuration schemas.
 */
export const workspaceListToolSourceKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolSourceKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/tool-sources/kinds`,
    options,
  );
};

export const getWorkspaceListToolSourceKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/tool-sources/kinds`,
  ] as const;
};

export const getWorkspaceListToolSourceKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListToolSourceKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListToolSourceKinds>>
  > = ({ signal }) =>
    workspaceListToolSourceKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListToolSourceKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListToolSourceKinds>>
>;
export type WorkspaceListToolSourceKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListToolSourceKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolSourceKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolSourceKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListToolSourceKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListToolSourceKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available tool source kinds and their configuration schemas.
 */

export function useWorkspaceListToolSourceKinds<
  TData = Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListToolSourceKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListToolSourceKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
